import noop from 'utils/noop';

export const saveFile = async (url: string, fileName: string): Promise<boolean> => {
  noop();
  return true;
};
